// extracted by mini-css-extract-plugin
export var shop = "SideBarInfo-module--shop--3HQzg";
export var image = "SideBarInfo-module--image--V5AGN";